import React, { useState } from "react";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import RadioBtn from "../../../../Button/RadioBtn";
import FixedInfoBox from "../../../../DefaultStyles/FixedInfoBox";
import Flex from "../../../../DefaultStyles/Flex";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { Textarea } from "../../../../Input/Textarea";
import PartyExitAlertModal from "./PartyExitAlertModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import AlertModal from "../../../../Modal/AlertModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";
import { getShareDefData, GetSubscriptionSetData_V3 } from "../../../../../ApiTS/ServiceDatasTS_V3";

export interface IPartyExitPartyData {
  uid: string;
  name: string;
  nickname: string;
  partyId: string;
  subsId: number;
  grade: number;
  membs: number;
  svcId?: number;
  startdate?: string;
}

interface PartyExitModalProps extends DefaultModalCommonProps {
  partyData: IPartyExitPartyData;
  confirmEvent: () => void;
  ssetValue?: number;
}

export default function PartyExitModal({
  partyData,
  closeEvent,
  confirmEvent,
  ssetValue,
}: PartyExitModalProps) {
  const [exitClick, setExitClick] = useState(false);
  const [reason, setReason] = useState("");
  const [needCheckAlertModal, setNeedCheckAlertModal] = useState(false);
  const [check, setCheck] = useState({
    first: false,
    second: false,
    third: false,
    fourth: false,
    fifth: false,
  });

  const isUplusParty = partyData?.subsId === 900001;
  const subsData = GetSubscriptionSetData_V3(partyData?.subsId);
  const sharetype = getShareDefData(subsData?.SHARDEF_ID ?? 0, 0);
  const isApplyProxy = sharetype?.SHARDEF_TYP === "apply_proxy";

  return (
    <DefaultModalLayout
      modalTitle={partyData?.grade === 0 ? "파티 해산" : "파티 탈퇴"}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (ssetValue! > 0) {
          setNeedCheckAlertModal(true);
        } else {
          setExitClick(true);
        }
      }}
      modalDesc={
        partyData?.grade === 0 ? "즉시 해산됩니다." : "즉시 탈퇴합니다."
      }
      confirmDisabled={
        reason === "" ||
        Object.values(check).filter((item) => item === true).length === 0
      }
      isOverflowVisible={false}
    >
      <ModalSection>
        <ModalSectionLabel>회원 정보</ModalSectionLabel>

        <Flex gapSize={11}>
          <FixedInfoBox label="UID" value={partyData?.uid} />
          <FixedInfoBox label="이름" value={partyData?.name} />
          <FixedInfoBox label="닉네임" value={partyData?.nickname} />
        </Flex>
      </ModalSection>

      <ModalSection>
        <ModalSectionLabel>파티 정보</ModalSectionLabel>

        <FixedInfoBoxContainer>
          <FixedInfoBox label="PID" value={partyData?.partyId} />
          <GridContainer>
            <FixedInfoBox
              label="Subscription"
              value={`${partyData?.subsId}_${getSubsNameBySubsId3(
                partyData?.subsId,
              )}`}
            />
          </GridContainer>
        </FixedInfoBoxContainer>
      </ModalSection>

      <ModalSection>
        <ModalSectionLabel>구분</ModalSectionLabel>

        <RadioBtnContainer>
          {!isApplyProxy && (
            <RadioBtn
              label="무책"
              clickEvent={() =>
                setCheck({
                  first: !check.first,
                  second: false,
                  third: false,
                  fourth: false,
                  fifth: false,
                })
              }
              check={check.first}
            />
          )}

          {!isUplusParty && !isApplyProxy && (
            <>
              <RadioBtn
                label="무책 일할"
                clickEvent={() =>
                  setCheck({
                    first: false,
                    second: !check.second,
                    third: false,
                    fourth: false,
                    fifth: false,
                  })
                }
                check={check.second}
              />

              <RadioBtn
                label="유책"
                clickEvent={() =>
                  setCheck({
                    first: false,
                    second: false,
                    third: !check.third,
                    fourth: false,
                    fifth: false,
                  })
                }
                check={check.third}
              />

              <RadioBtn
                label={partyData?.grade === 0 ? "먹튀" : "보상"}
                clickEvent={() =>
                  setCheck({
                    first: false,
                    second: false,
                    third: false,
                    fourth: !check.fourth,
                    fifth: false,
                  })
                }
                check={check.fourth}
              />
            </>
          )}

          {isApplyProxy && (
            <RadioBtn
              label={"Apply Proxy 해산"}
              clickEvent={() =>
                setCheck({
                  first: false,
                  second: false,
                  third: false,
                  fourth: false,
                  fifth: !check.fifth,
                })
              }
              check={check.fifth}
            />
          )}
        </RadioBtnContainer>
      </ModalSection>

      <ModalSection>
        <ModalSectionLabel>사유</ModalSectionLabel>

        <Textarea
          placeholder="내용 입력 (필수)"
          style={{ marginTop: 16 }}
          onChange={(e) => setReason(e.target.value)}
          value={reason}
        />
      </ModalSection>

      <>
        {needCheckAlertModal && (
          <AlertModal
            title={`이 파티는 종료 예정(일몰 처리중)인 파티입니다.
작업을 계속 하시겠습니까?`}
            cancelEvent={() => setNeedCheckAlertModal(false)}
            confirmEvent={() => {
              setExitClick(true);
              setNeedCheckAlertModal(false);
            }}
          />
        )}

        {exitClick && (
          <PartyExitAlertModal
            cancelEvent={() => setExitClick(false)}
            closeEvent={() => {
              closeEvent();
              if (confirmEvent) confirmEvent();
            }}
            partyData={partyData}
            reason={reason}
            check={check}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

export const ModalSection = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const ModalSectionLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.buttonColor.linePressed};
`;

const FixedInfoBoxContainer = styled.div`
  width: 100%;
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 11px;
`;

const GridContainer = styled.div`
  &:nth-child(1) {
    grid-column: 1;
  }
  &:nth-child(2) {
    grid-column: 2 / 4;
  }
`;

const RadioBtnContainer = styled.div`
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, 109px);
`;
